/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 10:59:42
 * @LastEditors: Yi Yunwan
 * @LastEditTime: 2021-01-20 12:28:49
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css'
import './styles/index.scss'
import '@/vant'
import { useDebug } from './utils'
Vue.config.productionTip = false
Vue.prototype.$debug = useDebug()
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
